import { CalendarDateLike } from '../types/calendar-date-like';

// Shape-only: enforces `yyyy-MM-dd` like but does not validate real calendar correctness
// (e.g. it allows `2024-13-40`, and it allows `0000-00-00`).
const CALENDAR_DATE_LIKE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Returns `true` when `value` matches the `yyyy-MM-dd` calendar-date shape.
 */
export function isCalendarDateLike(value: unknown): value is CalendarDateLike {
  return typeof value === 'string' && CALENDAR_DATE_LIKE_REGEX.test(value);
}
